import { QueryFilter, FilterKeys } from "../interfaces/filters";

// HELPERS
/**
 * A helper to filter out empty strings.
 * @param filters the string array to filter.
 * @returns a new string array without empty values.
 */
function percolate(filters: string[]) {
  let filteredFilters: Array<string> = [];
  if (filters.length !== 0) {
    filteredFilters = filters.filter((f) => f && f);
  }
  return filteredFilters;
}

function organiseFilters(queryFilters: QueryFilter<FilterKeys>[]) {
  // arrays to hold the filter groups
  const andFilters: Array<string> = [];
  const orFilters: Array<string> = [];
  const basicFilters: Array<string> = [];

  // divide filters into groups
  queryFilters.forEach((qf) => {
    switch (qf.parentFilter) {
      case "and":
        andFilters.push(qf.filter);
        break;
      case "or":
        orFilters.push(qf.filter);
        break;
      default:
        basicFilters.push(qf.filter);
        break;
    }
  });

  // collect the filters
  const collectedFilters = [
    andBuilder(andFilters),
    orBuilder(orFilters),
    basicFilters,
  ];

  // map the filters to a string
  const filterString = collectedFilters.map((f) => f).join("");

  // return the filter string
  return filterString;
}

export function buildFilter(queryFilters: QueryFilter<FilterKeys>[]) {
  if (queryFilters.length > 0) {
    const organisedFilters = organiseFilters(queryFilters);
    return whereBuilder(organisedFilters);
  } else {
    return "";
  }
}

// WRAPPERS
function whereBuilder(andOrFilter: string) {
  if (!andOrFilter) {
    return "";
  }
  const w = `where: {\n ${andOrFilter}\n}`;

  // 4 testing
  // console.log(w);

  return w;
}

function andBuilder(filters: string[]) {
  const percolatedFilters = percolate(filters);

  return percolatedFilters.length !== 0
    ? `and: [\n  ${percolatedFilters
        .map((value) => `${value}`)
        .join("\n  ")}\n ]\n`
    : "";
}

function orBuilder(filters: string[]) {
  const percolatedFilters = percolate(filters);
  return percolatedFilters.length !== 0
    ? `or: [\n  ${percolatedFilters
        .map((value) => `${value}`)
        .join("\n  ")}\n ]\n`
    : "";
}
